<template>
  <v-container class="fill-height agencies" fluid style="min-height:100vh; background:#FFE7D7;">
    <v-row>
      <v-spacer/>
      <div>
        <v-row class="ma-0">
          <v-spacer/>
            <div>
              <img width="200" src="/LogoPEACH.png"/>
            </div>
          <v-spacer/>
        </v-row>
        <v-row class="ma-0">
          <v-spacer/>
            <v-card-title>Login</v-card-title>
          <v-spacer/>
        </v-row>
        <v-row class="ma-0">
          <v-spacer/>
          <div style="width:400px;">
            <v-alert class="mt-5" text dense type="error" v-if="alerta"> 
              <strong>Usuario</strong> y/o <strong>contraseña</strong> incorrecta(s)
            </v-alert>
            <v-text-field 
              :rules="[rules.required, rules.email]"
              @keydown.enter="login" 
              rounded 
              label="Correo Electrónico" 
              name="login" 
              type="email" 
              v-model="user.email" 
              aria-describedby="emailHelp"
              :hide-details="true"
            ></v-text-field>
            <v-text-field 
              :rules="[rules.required]"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              name="password"
              label="Contraseña"
              @click:append="show1 = !show1"
              @keydown.enter="login" 
              v-model="user.password"
              :hide-details="true"
              rounded
            ></v-text-field>
            <v-btn block dark color="primary" type="submit" @click="login" class="elevation-0 py-7 mt-4" rounded><strong>Acceder</strong></v-btn>
          </div>
          <v-spacer/>
        </v-row>
      </div>
      <v-spacer/>
    </v-row>
  </v-container>
</template>

<!----------------------- Scripts ----------------------->
<script>
export default{
    data:()=>({
      alerta: false,
      show: false,
      show1: false,
      password: 'Password',
      rules: {
          required: value => !!value || 'Contraseña requerida.',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'E-mail inavlido.'
          }
      },
      user:{
          email: "",
          password: "",
      }
    }),
    methods:{
        login(){
            this.$store.dispatch('currentUser/loginUser', this.user );
            this.alerta = localStorage.getItem("nosepudo")
        }, 
    }
}
</script>

<style>
.agencies .v-input__slot {
  background:#F4F4F4;
  padding:10px 20px!important;
}
</style>
